import { render, staticRenderFns } from "./Indigator.vue?vue&type=template&id=6fb58d60&scoped=true&"
import script from "./Indigator.vue?vue&type=script&lang=js&"
export * from "./Indigator.vue?vue&type=script&lang=js&"
import style0 from "./Indigator.vue?vue&type=style&index=0&id=6fb58d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb58d60",
  null
  
)

export default component.exports